import { action, observable, makeObservable } from 'mobx';

class GameStore {
  // gameTypeId = null;

  isBetsClosed = false;

  isPigMultiplierInvisible = false;

  multiplierData = {};

  isPongReceived = false;

  gameStatus = null;

  constructor() {
    makeObservable(this, {
      // gameTypeId: observable,
      gameStatus: observable,
      isBetsClosed: observable,
      isPongReceived: observable,
      isPigMultiplierInvisible: observable,
      multiplierData: observable.deep,
      setGameStatus: action.bound,
      setIsPigMultiplierInvisible: action.bound,
      // setGameTypeId: action.bound,
      setIsBetsClosed: action.bound,
      setIsPongReceived: action.bound,
      setMultiplierData: action.bound,
    });
  }

  setIsPigMultiplierInvisible(arg) {
    this.isPigMultiplierInvisible = arg;
  }

  setMultiplierData(data) {
    this.multiplierData = data;
  }

  setIsBetsClosed(arg) {
    this.isBetsClosed = arg;
  }

  setGameStatus(gameStatus) {
    this.gameStatus = gameStatus;
  }

  setIsPongReceived(isPongReceived) {
    this.isPongReceived = isPongReceived;
  }

  // setGameTypeId() {
  //   const { [DefaultQueryParams.GameTypeId]: gameTypeId } = parseQuery(window.location.search);
  //   this.gameTypeId = gameTypeId;
  // }
}

export const gameStore = new GameStore();
